import type { ColumnDef } from "@tanstack/react-table";
import { DataTable } from "@/components/ui/data-table";
import { InvitedAffiliate } from "../../services/brand.service";

interface InvitedAffiliatesTableProps {
  data: InvitedAffiliate[];
  isLoading?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const columns: ColumnDef<InvitedAffiliate, any>[] = [
  {
    id: "email",
    header: "Email",
    cell: ({ row }) => (
      <span className="block break-all">{row.original.email}</span>
    ),
    meta: { width: "w-[40%]" },
  },
  {
    id: "status",
    header: "Status",
    cell: ({ row }) => (
      <div className="flex items-center">
        <span
          className={`inline-flex items-center gap-1 ${
            row.original.status === "PENDING"
              ? "text-yellow-700"
              : row.original.status === "ACCEPTED"
              ? "text-green-700"
              : "text-red-700"
          }`}
        >
          <span
            className={`w-1.5 h-1.5 rounded-full ${
              row.original.status === "PENDING"
                ? "bg-yellow-500"
                : row.original.status === "ACCEPTED"
                ? "bg-green-500"
                : "bg-red-500"
            }`}
          ></span>
          <span>{row.original.status}</span>
        </span>
      </div>
    ),
    meta: { width: "w-[30%]" },
  },
  {
    id: "emailStatus",
    header: "Email Status",
    cell: ({ row }) => (
      <div className="flex items-center">
        <span
          className={`inline-flex items-center gap-1 ${
            row.original.emailStatus === "SENT"
              ? "text-green-700"
              : "text-yellow-700"
          }`}
        >
          <span
            className={`w-1.5 h-1.5 rounded-full ${
              row.original.emailStatus === "SENT"
                ? "bg-green-500"
                : "bg-yellow-500"
            }`}
          ></span>
          <span>{row.original.emailStatus}</span>
        </span>
      </div>
    ),
    meta: { width: "w-[30%]" },
  },
];

export function InvitedAffiliatesTable({
  data,
  isLoading,
}: InvitedAffiliatesTableProps) {
  return (
    <DataTable
      columns={columns}
      data={data}
      isLoading={isLoading}
      emptyText="No invited affiliates"
      getRowId={(row) => row.id}
    />
  );
}
